import { useState } from "react";
import { api } from "../lib/api";

export function Shot({ sha, alt, className = "thumb" }: { sha: string; alt?: string; className?: string }) {
  const [big, setBig] = useState(false);
  return (
    <>
      <img className={className} src={api.blobUrl(sha)} alt={alt ?? "screenshot"} onClick={() => setBig(true)} loading="lazy" />
      {big && (
        <div className="lightbox" onClick={() => setBig(false)}>
          <img className="shot-big" src={api.blobUrl(sha)} alt={alt ?? "screenshot"} />
        </div>
      )}
    </>
  );
}
